import axios from 'axios';
import { apiUrl } from '../../config/config';

axios.defaults.baseURL = apiUrl;

//
// if (window.location.hostname === "vadmin.stagelab.co.uk") {
// }

axios.defaults.headers.common.Accept = 'application/json';
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.headers.common['Content-Type'] = 'application/json';

export default axios;



// WEBPACK FOOTER //
// ./src/system/utils/Http.js